import { render, staticRenderFns } from "./reservation-editor.vue?vue&type=template&id=28966154&scoped=true&"
import script from "./reservation-editor.vue?vue&type=script&lang=js&"
export * from "./reservation-editor.vue?vue&type=script&lang=js&"
import style0 from "./reservation-editor.vue?vue&type=style&index=0&id=28966154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28966154",
  null
  
)

export default component.exports